import React, { useState } from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Calendar from "../../Components/Calendar/Calendar";
import Banners from "../../Components/Banners/Banners";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import Help from "../../Components/Help/Help";
import dashboardHelp from "./homeHelp";
import BottomBar from "../../Components/BottomBar/BottomBar";
import Alert from "../../Components/Alert/Alert";
import Coins from "../../Components/Coins/Coins";
import SendReport from "../../Components/SendReport/SendReport";
import { useAuth } from "../../AuthContext";
import MailIcon from "../../Components/MailIcon/MailIcon";
import useMainProfile from "../../Hooks/useMainProfile";
import useUnCompleted from "../../Hooks/useUnCompleted";
// import usePlansForms from "../../Hooks/usePlansForms";
import CourseFormModal from "../../Components/CourseFormModal/CourseFormModal";
import { useLocation } from "react-router-dom";
import Sessions from "../../Components/Sessions/Sessions";
import useCheckForms from "../../Hooks/useCheckUnForms";

export default function Home() {
  const location = useLocation();
  const { userToken } = useAuth();
  const { dietForms, exerciseForms } = useUnCompleted(userToken);
  const { userMainData } = useMainProfile(userToken);
  // const { currentDietPlans, currentExercisePlans } = usePlansForms(userToken);
  const [showFormModal, setShowFormModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const { medicalFormId, modalLabel } = useCheckForms(
    dietForms,
    exerciseForms,
    setShowFormModal,
    setModalText
  );
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  const handleReportAlert = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("مجاز نیست");
  };

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showModalHandler = () => {
    setShowQuestionModal(true);
  };

  const handleClose = () => {
    setShowQuestionModal(false);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    setAlertText("به زودی");
  };

  const handleDateSelection = (date) => {
    setSelectedDate(date);
  };

  const hideFormModal = () => {
    setShowFormModal(false);
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="home pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="homeHeaderRight centeredFlex">
              <MailIcon loc={location.pathname} />
              <Coins onShowAlert={showAlertHandler} />
            </div>
            <div className="homeHeaderLeft centeredFlex">
              <Link to="/download" className="link">
                <img src="/images/pdf_download.svg" alt="pdf" className="pdfIcon" />
              </Link>
              <Help
                showQuestionModal={showQuestionModal}
                onShow={showModalHandler}
                onHide={handleClose}
                data={dashboardHelp}
              />
              <img
                src="/images/ic_menu.svg"
                alt="menu"
                className="menuIcon"
                onClick={hamburgerMenuHandler}
              />
            </div>
          </div>
          <div className="homeContent scroll">
            <div className="homeContentTop horizontalBorder centeredFlex">
              <div className="homeUserName">
                {userMainData && userMainData.latin_name ? (
                  <h2>
                    {userMainData.latin_name.length > 7
                      ? userMainData.latin_name.slice(0, 7) + "..."
                      : userMainData.latin_name}
                  </h2>
                ) : (
                  <h2></h2>
                )}
              </div>
              <SendReport from="home" onShowAlert={handleReportAlert} />
            </div>
            <Calendar onDateSelect={(date) => handleDateSelection(date)} />
            <Sessions selectedDate={selectedDate} />
            <Banners />
          </div>
          <Alert alertText={alertText} showAlert={showAlert} />
          <CourseFormModal
            show={showFormModal}
            onHandleHide={hideFormModal}
            btnText="تکمیل فرم"
            body={modalText}
            id={medicalFormId}
            label={modalLabel}
          />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
